module.exports = __webpack_public_path__ + "img/coin-big.5e1b2314.png";